import {getSecondsOfDay} from "../../../../../Apis/functions";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Validates that the "to" time value is greater than the "from" time value.
 * @param {string|Date} fromValue - The starting time value.
 * @param {string|Date} toValue - The ending time value.
 * @returns {boolean} Returns true if the "to" value is greater than the "from" value; otherwise false.
 */
export const isToValueValid = (fromValue, toValue) => {
    const fromSeconds = getSecondsOfDay(fromValue);
    const toSeconds = getSecondsOfDay(toValue);

    if (fromSeconds === null || toSeconds === null) return false;

    return toSeconds > fromSeconds;
}
